import * as Vue from 'vue';
export default {
  props: ['content'],
  data() {
    return {};
  }
};